import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { SimpleDropdown } from '../../../../../../../../../components/simple-dropdown';
import { MOVEMENT_INDICATORS } from '../../../../../../../../../orders/other-shipping-options/components/inputs/windsor-framework-movement-indicator-dropdown/movement-indicators';
import { PARAMETER } from '../../../../../../constants/parameter-name-for-update';

import { messages } from './messages';

type AddMovementIndicatorProps = {
  onChange: (value: Record<string, string>) => void;
  inputValueProps?: Record<string, string>;
};

export const AddMovementIndicator: FC<AddMovementIndicatorProps> = ({ onChange, inputValueProps }): JSX.Element => {
  const intl = useIntl();
  const [selectedIndicator, setSelectedIndicator] = useState<string>();

  useEffect(() => {
    if (!inputValueProps?.parameter) {
      return;
    }

    setSelectedIndicator(inputValueProps.parameter);
  }, [inputValueProps?.parameter]);

  const onSelectionMade = useCallback(
    (indicatorId: string) => {
      setSelectedIndicator(indicatorId);
      onChange({
        [PARAMETER]: indicatorId,
      });
    },
    [onChange],
  );

  return (
    <FlexColumn gap={Gap.Space4}>
      <Text textType={TextType.Label} value={messages.label} />
      <SimpleDropdown
        defaultTitle={intl.formatMessage(messages.placeholder)}
        dropdownMenuShouldHaveWidthOfButton
        fullWidth
        items={MOVEMENT_INDICATORS.map((indicator) => ({
          key: indicator.id,
          name: intl.formatMessage(indicator.label),
        }))}
        onItemSelected={onSelectionMade}
        selectedItemKey={selectedIndicator}
      />
    </FlexColumn>
  );
};
